import React from 'react';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  img: {
    width: 'auto',
    height: 30,
  },
});

const LogoFull = () => {
  const classes = useStyles();

  return (
    <img
      src="/planet_logo.svg"
      alt="WeArePlanet"
      className={classes.img}
    />
  );
};

export default LogoFull;
